
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiCrm from './vendors/farlo-ui-crm.js';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox';

// Import Footer Components
import { cookieCompliance } from './components/footer/cookieCompliance.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { navicon } from './components/footer/navicon.js';
import { navigation } from './components/footer/navigation.js';
import { smoothScroll } from './components/footer/smoothScroll.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { clock } from './components/footer/clock.js';
import { expand } from './components/footer/expand.js';
import { redacted } from './components/footer/redacted.js';
import { fixedColumnOnScroll } from './components/footer/fixedCOlumnOnScroll.js';
import { farloUiGallerySlider } from './components/footer/flickity-gallery.js';
import { farloUiPodcastSlider } from './components/footer/flickity-podcast.js';
import { farloUiMasthead } from './components/footer/flickity-masthead.js';
import { stickyColumn } from './components/footer/sticky.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function (state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {

		if (document.querySelector('.fixed-on-scroll')) {

			fixedColumnOnScroll();

		}

		if (document.querySelector('.sticky-container')) {
			stickyColumn();
		}

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.clock')) {
			clock();
		}

		if (document.querySelector('.is-style-redacted')) {
			redacted();
		}

		if (document.querySelector('.wp-block-embed')) {
			document.querySelectorAll('.wp-block-embed__wrapper').forEach(function (_sel) {
				const embedDiv = document.createElement('div');

				if (!(_sel.querySelector('.wp-block-embed__player'))) {
					embedDiv.className = 'wp-block-embed__player';
					_sel.append(embedDiv);

					embedDiv.addEventListener('click', (e) => {
						const iframe = e.currentTarget.parentNode.querySelector('iframe');
						const dataSrc = iframe.getAttribute('data-src') || iframe.getAttribute('src');

						e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');

						// Remove the existing iframe
						iframe.remove();

						// Create a new iframe with autoplay parameters
						const newIframe = document.createElement('iframe');
						newIframe.setAttribute('src', dataSrc + '&autoplay=1&playsinline=1&muted=1');
						newIframe.setAttribute('allow', 'autoplay'); // Ensure autoplay is allowed
						newIframe.setAttribute('frameborder', '0');
						newIframe.setAttribute('allowfullscreen', '');

						// Append the new iframe to the wrapper
						e.currentTarget.parentNode.appendChild(newIframe);
					});
				}
			});
		}



		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
			const formId = _sel.getAttribute('id');

			new FarloUiCrm({ formId });
		});

		if (document.querySelector('.expand-block')) {
			expand();
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		if (document.querySelector('.site-podcast-page__gallery')) {
			document.querySelectorAll('.site-podcast-page__gallery').forEach((_sel) => {
				farloUiGallerySlider(_sel);
			});
		}

		if (document.querySelector('.cards-slider__enable')) {
			document.querySelectorAll('.cards-slider__enable').forEach((_sel) => {
				farloUiPodcastSlider(_sel);
			});
		}

		if (document.querySelector('.masthead-slider')) {
			document.querySelectorAll('.masthead-slider').forEach((_sel) => {
				farloUiMasthead(_sel);
			});
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScroll(_sel);
		});

		if (document.querySelector('.rank-math-list-item')) {
			document.querySelectorAll('.rank-math-question').forEach((_el) => {
				_el.dataset.toggled = '0';
				_el.addEventListener('click', () => {
					toggleFAQ(_el);
				});
			});
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.site-farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				_sel.farloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}
		if (document.querySelector('input[type="number"]')) {
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}


		if (document.querySelector('.gfield_list_icons')) {
			document.querySelectorAll('.gfield_list_icons').forEach(function (buttonContainer) {
				new FarloUiList(buttonContainer);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function (registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
